import * as $ from "jquery";
import imkt from '../../../imkt';
import "waypoints/lib/jquery.waypoints.js";
import '@types/waypoints/jquery';

imkt.landing.MeInTeamInfographic = class MeInTeamInfographic {
  constants = {
    DEFAULT_ANIMATION_TIMING: 500,
    SMALL_SCREEN_BREAKPOINT: 800,
  };
  $domRoot: JQuery<HTMLElement>;
  $readMoreButton: JQuery<HTMLElement>;
  $backToTopButton: JQuery<HTMLElement>;
  $scrollTrigger: JQuery<HTMLElement>;
  $viewSourcesButton: JQuery<HTMLElement>;
  $sourcesContainer: JQuery<HTMLElement>;
  $subFooterLinksArea: JQuery<HTMLElement>;
  params: {};

  constructor(domRoot: HTMLElement, params: {}) {
    this.$domRoot = $("body");
    this.$readMoreButton = $("#jsReadTips", this.$domRoot);
    this.$backToTopButton = $("#backToTopColumn a", this.$domRoot);
    this.$scrollTrigger = $(".js-scrollTrigger", this.$domRoot);
    this.$viewSourcesButton = $("#viewSourcesColumnLink a", this.$domRoot);
    this.$sourcesContainer = $(".source-list-column", this.$domRoot);
    this.$subFooterLinksArea = $(".me-team__subfooter-links-area", this.$domRoot);

    this.params = { ...params };

    this.init();
  }
  
  init() {
    if ($("body").hasClass("edit")) {
      return;
    }

    this.bindEvents();
  }

  isNarrowScreen() {
    return $(window).width() <= this.constants.SMALL_SCREEN_BREAKPOINT;
  }

  bindEvents() {
    var self = this;

    // Scroll down to first section when arrow is clicked
    this.$readMoreButton.click(function () {
      $("html, body").animate(
        {
          scrollTop: $(self.$readMoreButton.attr("href")).offset().top,
        },
        self.constants.DEFAULT_ANIMATION_TIMING
      );
      return false;
    });

    // Scroll back to top
    this.$backToTopButton.click(function () {
      $("html, body").animate(
        {
          scrollTop: $(self.$backToTopButton.attr("href")).offset().top,
        },
        self.constants.DEFAULT_ANIMATION_TIMING * 2
      );
      return false;
    });

    // Open sources list
    this.$viewSourcesButton.click(function () {
      var $this = $(this);

      self.$sourcesContainer.slideToggle();
      $this.toggleClass("open", self.constants.DEFAULT_ANIMATION_TIMING);

      if ($this.hasClass("open")) {
        $("html, body").animate(
          {
            scrollTop: self.$subFooterLinksArea.offset().top,
          },
          self.constants.DEFAULT_ANIMATION_TIMING
        );
      }

      return false;
    });

    // Scroll events
    if (this.isNarrowScreen()) {
      this.$scrollTrigger.each(function () {
        var $el = $(this);
        $el.waypoint(
          function () {
            $el.addClass("active-in");

            // remove handler after waypoint fires once
            this.destroy();
          },
          {
            offset: 0, // default
          }
        );
      });
    } else {
      this.$scrollTrigger.each(function () {
        var $el = $(this);
        $el.waypoint(
          function (direction) {
            if (direction === "down") {
              $el.removeClass("active-out").addClass("active-in");
            }
          },
          {
            offset: "bottom-in-view",
          }
        );

        $el.waypoint(
          function (direction) {
            if (direction === "up") {
              $el.addClass("active-out").removeClass("active-in");
            }
          },
          {
            offset: "15%",
          }
        );
      });
    }
  }
}

new imkt.landing.MeInTeamInfographic();
